export const faqSections = {
    general: {
        title: "Getting Started",
        slides: [
            {
                subtitle: "CareX Data Collector",
                description: "Learn the features of Data Collector and how to get started with our platform. We'll guide you through the essential features.Before you begin studying or taking measurements, please take a moment to review these guidelines to understand the key features.  ",
                bgColor: "bg-gradient-blue",

            },


        ]
    },
    features: {
        title: "Adding the patient",
        slides: [
            {
                subtitle: "How to add a first patient",
                description: "To get started with tracking patient information, simply click the 'Add Your First Patient' button located on your dashboard. This will open the patient registration form, allowing you to enter the essential details for your new patient.If you have not added any patients yet, this button will be prominently displayed to help you begin using our system quickly and easily.",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/add_patient_zero.png"),
                    alt: "Product Introduction",
                    width: 800,  // Optional: specify dimensions
                    height: 600,
                    position: "top" //| "bottom" | "left" | "right" // Optional: control image placement
                }
            },
            {
                subtitle: "How to add a new patient",
                description: "If you have already added a patient and want to add a new one, the 'New Patient' button will appear on the right side of the screen as follows.",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/add_patient_one.png"),
                    alt: "Product Introduction",
                    width: 800,  // Optional: specify dimensions
                    height: 600,
                    position: "top" // | "bottom" | "left" | "right" // Optional: control image placement
                }
            },
            {
                subtitle: "Detailed Information Collection",
                paragraphs: [
                    "When you begin adding a new patient, a comprehensive dialog will open to capture important patient information. This detailed form will guide you through a series of questions about the patient's medical background, personal details, and relevant health information.",
                    "We recommend carefully completing each section with the most accurate and appropriate information for the patient. Our system includes built-in validation to help ensure data accuracy. If you enter any information that doesn't meet our data requirements, helpful warning messages will appear, allowing you to review and correct the entry as needed.",
                    "Take your time to provide thorough and precise information, following the system's guidance to create a complete and accurate patient record."
                ],
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/add_patient_two.png"),
                    alt: "Product Introduction",
                    width: 800,  // Optional: specify dimensions
                    height: 600,
                    position: "top" // | "bottom" | "left" | "right" // Optional: control image placement
                }
            },
            {
                subtitle: "Completing Patient Registration",
                paragraphs: [
                    "After carefully filling out the patient information form, click the 'Add Patient' button to save the record. Once the system successfully processes and stores the information, the dialog will automatically close.",
                    "You'll then see the newly added patient's information displayed on your dashboard. This overview provides a quick snapshot of the patient's profile, including a summary of measurements. You can easily view the number of measurements taken for this patient, both daily and in total.",
                    "Ready to begin taking measurements? Look for the patient's entry on the dashboard and proceed with measurements. For detailed guidance on the measurement process, please refer to our 'How to Take Measurements' section, which provides comprehensive instructions to ensure accurate and consistent data collection."
                ],
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/add_patient_three.png"),
                    alt: "Product Introduction",
                    width: 800,  // Optional: specify dimensions
                    height: 600,
                    position: "top" // | "bottom" | "left" | "right" // Optional: control image placement
                }
            }
        ]
    },
    measurements: {
        title: "Taking Measurement",
        slides: [
            {
                subtitle: "Select the patient",
                description: "You can proceed to the measurement screen by clicking on the patient you want to measure.",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/select_patient.png"),
                    alt: "Product Introduction",
                    width: 800,  // Optional: specify dimensions
                    height: 600,
                    position: "top" //| "bottom" | "left" | "right" // Optional: control image placement
                }
            },
            {
                subtitle: "Connecting Your Devices",
                paragraphs: [
                    "When you access the device connection screen, you'll see a list of your connected devices. If the devices are not immediately visible, simply use the refresh button located on the right side of the section to update the display.",
                    "This screen provides comprehensive options for managing your devices. You can configure camera settings, set up Bluetooth device connections, and view detailed features of each connected device. Take a moment to review and adjust your device settings to ensure smooth and efficient data collection."
                ],
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/devices.png"),
                    alt: "Product Introduction",
                    width: 800,  // Optional: specify dimensions
                    height: 600,
                    position: "top" // | "bottom" | "left" | "right" // Optional: control image placement
                }
            },
            {
                subtitle: "Start a Measurement",
                description: "Once you ready to begin taking measurements, click the 'Start Measurement' button to initiate the process. This action will open the measurement screen.",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/new_recording.png"),
                    alt: "Product Introduction",
                    width: 800,  // Optional: specify dimensions
                    height: 600,
                    position: "top" //| "bottom" | "left" | "right" // Optional: control image placement
                }
            },
            {
                subtitle: "Blood Pressure Measurement Process",
                paragraphs: [
                    "For blood pressure measurements, you will need to take two separate readings. Prior to beginning, you will receive two sets of login credentials for accessing the web application. Log in using these provided credentials to the same web application.",
                    "Upon logging in, you will be directed to a specific screen designed for entering blood pressure measurement results. This screen will guide you through the process of recording your two required measurements. Carefully enter each reading, ensuring accuracy and completeness in your data input."
                ],
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/bp.png"),
                    alt: "Product Introduction",
                    width: 800,  // Optional: specify dimensions
                    height: 600,
                    position: "top" // | "bottom" | "left" | "right" // Optional: control image placement
                }
            },
            {
                subtitle: "Blood Pressure Measurement Verification",
                paragraphs: [
                    "When you complete your two blood pressure measurements, our system will immediately compare the readings for consistency. If the two measurements are sufficiently close to each other, you'll see a confirmation screen indicating that the measurements are acceptable. In this case, you can proceed with the next steps of your measurement process after receiving the system's approval.",
                    "However, if the difference between the two measurements exceeds a specific threshold, the system will flag the readings as inconsistent. You will then be prompted to retake the blood pressure measurement to ensure accuracy and reliability of the data. This careful verification process helps maintain the highest standards of medical data collection."
                ],
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/bp_2.png"),
                    alt: "Product Introduction",
                    width: 800,  // Optional: specify dimensions
                    height: 600,
                    position: "top" // | "bottom" | "left" | "right" // Optional: control image placement
                }
            },
            {
                subtitle: "Device Information Review",
                paragraphs: [
                    "Before proceeding with your measurement, you'll be presented with a final screen displaying all device information. This is your opportunity to carefully review and verify the details. You can make any necessary adjustments to the device settings at this stage.",
                    "Please note that once you move past this screen, you will no longer be able to modify the device information. Take a moment to ensure all settings are correct and match your intended measurement requirements."
                ],
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/measurement1.png"),
                    alt: "Product Introduction",
                    width: 800,  // Optional: specify dimensions
                    height: 600,
                    position: "top" // | "bottom" | "left" | "right" // Optional: control image placement
                }
            },
            {
                subtitle: "Camera Setup and Patient Positioning",
                paragraphs: [
                    "When you proceed, the device cameras will activate. At this point, your primary focus will be on positioning the patient correctly. The camera view is critical for accurate measurement, so you'll need to carefully adjust the patient's posture and positioning.",
                    "Ensure that the patient's entire face is clearly visible within the camera frame. The system requires optimal facial distance, precise orientation, and proper alignment. As you position the patient, the system will provide real-time guidance and notifications if any positioning errors are detected. Pay close attention to these alerts to achieve the most accurate and reliable measurement possible.",
                    "Take your time to make these adjustments, as proper positioning is essential for obtaining high-quality medical data."
                ],
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/measurement2.png"),
                    alt: "Product Introduction",
                    width: 800,  // Optional: specify dimensions
                    height: 600,
                    position: "top" // | "bottom" | "left" | "right" // Optional: control image placement
                }
            },
            {
                subtitle: "Starting the Measurement Process",
                paragraphs: [
                    "Once the patient is properly positioned and ready for measurement across all devices, the Start button will become active. When you click this button, the measurement sequence will begin immediately.",
                    "During the measurement, you'll be able to monitor the progress directly on the screen, including the current measurement time. The system provides real-time monitoring to ensure the highest quality of data collection. If any errors occur during the measurement, you will receive instant notifications.",
                    "It is crucial to pay close attention to these error alerts and address them promptly during the measurement. Immediate correction of any issues helps maintain the accuracy and reliability of the medical data being collected."
                ],
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/measurement3.png"),
                    alt: "Product Introduction",
                    width: 800,  // Optional: specify dimensions
                    height: 600,
                    position: "top" // | "bottom" | "left" | "right" // Optional: control image placement
                }
            },
            {
                subtitle: "Completing the Measurement",
                paragraphs: [
                    "After successfully completing all device measurements, you'll be able to finalize the process by pressing the Stop button. Once pressed, the system will provide you with a comprehensive summary of the measurement results and device performance.",
                    "The final screen will give you detailed information about the measurements taken, allowing you to review the data and ensure everything has been captured accurately. This summary serves as a final checkpoint before concluding the measurement session."
                ],
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/measurement4.png"),
                    alt: "Product Introduction",
                    width: 800,  // Optional: specify dimensions
                    height: 600,
                    position: "top" // | "bottom" | "left" | "right" // Optional: control image placement
                }
            },
            {
                subtitle: "Blood Sugar Measurement Reporting",
                paragraphs: [
                    "The system will prompt you to provide information about your blood sugar level. If you have not taken a blood sugar measurement, you can simply select 'No' in response.",
                    "If you have performed a blood sugar measurement, you will need to enter two key pieces of information: the time of your last meal and your specific measurement result. Additionally, you have the option to include blood pressure information. However, if no blood pressure measurement has been taken, you can leave this field blank.",
                    "Accurate and complete information helps provide a comprehensive view of your health data."
                ],
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/measurement5.png"),
                    alt: "Product Introduction",
                    width: 800,  // Optional: specify dimensions
                    height: 600,
                    position: "top" // | "bottom" | "left" | "right" // Optional: control image placement
                }
            },
            {
                subtitle: "Finalizing Your Measurement",
                paragraphs: [
                    "After entering these information, you will reach the final screen of the measurement process. Here, you have two options: you can add a note about the measurement for additional context or simply close the measurement screen using the Close button.",
                    "If you wish to include any additional observations, comments, or relevant details about the measurement, you can do so before concluding the session. Otherwise, you can proceed to close the screen and complete the measurement process.",
                ],
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/measurement6.png"),
                    alt: "Product Introduction",
                    width: 800,  // Optional: specify dimensions
                    height: 600,
                    position: "top" // | "bottom" | "left" | "right" // Optional: control image placement
                }
            },

        ]
    },
    upload: {
        title: "Uploading Data",
        slides: [
            {
                subtitle: "Uploading",
                description: "Upload your measurements to your computer once you've finished recording them.",
                bgColor: "bg-gradient-blue"
            },
            {
                subtitle: "Finding Your Measurements",
                description: "To find your measurements, open the 'Saved Measurements' section on your iOS or Android device.",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/upload_ios.jpg"),
                    alt: "Product Introduction",
                    width: 800,  // Optional: specify dimensions
                    height: 600,
                    position: "top" // | "bottom" | "left" | "right" // Optional: control image placement
                }
            },
            {
                subtitle: "Sharing Multiple Measurements on iOS",
                description: "To share multiple measurements from your iOS device, tap the 3-dot menu icon in the top right. Select 'Share' from the menu. You can then choose AirDrop to transfer your data.",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/upload_all_ios.jpg"),
                    alt: "Product Introduction",
                    width: 800,  // Optional: specify dimensions
                    height: 600,
                    position: "top" //| "bottom" | "left" | "right" // Optional: control image placement
                }
            },
            {
                subtitle: "Sharing Individual Measurements on iOS",
                description: "To send measurements one by one, tap the 3-dot icon next to each measurement. Select 'Share' from the menu, then choose AirDrop to transfer the data.",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/upload_once_ios.jpg"),
                    alt: "Product Introduction",
                    width: 800,  // Optional: specify dimensions
                    height: 600,
                    position: "top" // | "bottom" | "left" | "right" // Optional: control image placement
                }
            },
            {
                subtitle: "File Transfer on Android",
                description: "You should use wired transfer for Android device. Your measurements are stored in the 'Android/data/ai.carex.datacollection/files/SavedMeasurements'  folder on your device. Connect your device with a USB cable and copy the files to your desired location on your computer.",
                bgColor: "bg-gradient-blue",
            }

        ]
    },
    stats: {
        title: "Patient Statistics",
        slides: [
            {
                subtitle: "Patient Statistics Overview",
                paragraphs: [
                    "At the bottom of the main screen, you'll find a comprehensive statistics section dedicated to the specific patient. This section provides a quick snapshot of the patient's measurement history, displaying both total and daily measurement numbers at a glance.",
                    "For a more in-depth view of the patient's measurement data, simply click on this section to expand it. This will reveal detailed information, allowing you to review the patient's measurement history with greater precision and insight."
                ],
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/stats_1.png"),
                    alt: "Features Overview"
                }
            },
            {
                subtitle: "Patient Measurement Statistics",
                paragraphs: [
                    "The statistics section offers a comprehensive overview of the patient's measurement history. Each recorded measurement is listed, providing key summary information at a glance.",
                    "To access more detailed information about a specific measurement, simply click on the individual measurement entry. This will open a comprehensive view with in-depth details about that particular measurement, allowing you to review the data more thoroughly.",
                    "Teleconference Meetings tab allows you to see the statistics about the teleconferences."
                ],
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/stats_2.png"),
                    alt: "Features Overview"
                }
            },
            {
                subtitle: "Device Information and Timeline",
                paragraphs: [
                    "Within each measurement's dedicated section, you can access comprehensive details about the devices used during that specific measurement. This includes technical specifications and performance information for the devices involved.",
                    "Additionally, you'll find a detailed timeline view displaying the information messages sent by the devices throughout the measurement process. This chronological record provides a clear and transparent overview of the entire measurement sequence, allowing you to track and understand each device's communication and status during the data collection.",
                    "In case of any error or failure to load, you can use the Refresh Details button."
                ],
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/stats_3.png"),
                    alt: "Features Overview"
                }
            }
        ]
    },
    loremipsum: {
        title: "Using Teleconfrence",
        slides: [
            {
                subtitle: "Logging in to Zoom",
                description: "Since our Teleconference sessions utilize Zoom, you'll need to login to your Zoom account by click on the drop-down on your username on the top-right corner",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/tele0.png"),
                    alt: "zoom start"
                }
            },
            {
                subtitle: "Zoom Authorization",
                description: "Once logged in, you'll be redirected to a page where you have to authorize our application. Simply click 'Allow' and you'll be automatically redirected to our application.",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/tele4.png"),
                    alt: "zoom start"
                }
            },
            {
                subtitle: "Starting the Teleconference",
                description: "To proceed to the teleconfrence modal, click on the 'Teleconference' button under the patient details",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/tele1.png"),
                    alt: "Teleconference start"
                }
            },
            {
                subtitle: "Creating Meetings",
                description: "You'll be prompted with a screen to bulk-create a number of meetings you would like to conduct with the patient. Keep in mind that, if needed, you can create more later on.",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/tele2.png"),
                    alt: "Teleconference start"
                }
            },
            {
                subtitle: "Joining Meetings",
                description: "After meetings creation, simply clicking on 'Join Meeting' will direct you to a new page that will start the Zoom meeting that the patient will join.",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/tele5.png"),
                    alt: "Teleconference start"
                }
            },
            {
                subtitle: "Patient Credentials",
                description: "Once the meeting is started, the patient will need to login to their Vitouch app using generated email and password at the top of the Modal",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/tele8.png"),
                    alt: "Teleconference start"
                }
            },
            {
                subtitle: "Patient Joining the Meeting",
                description: "The patient will click on 'Profile' on the bottom right corner, and then click on 'Zoom Study Meeting', which will automatically direct them to the meeting if it has started.",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/tele8.jpg"),
                    alt: "Teleconference start"
                }
            },
            {
                subtitle: "Meeting Hasn't started?",
                description: "If the meeting hasn't started, the patient will be sent to a waiting room where they will automatically join once the meeting is started.",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/tele9.jpg"),
                    alt: "Teleconference start"
                }
            },
            {
                subtitle: "Starting the Measurement",
                description: "Once the patient joins the meeting, they will be prompted to turn on their Bluetooth if they haven't, and to connect their pulse oximeter device and the measurement start automatically if the patient is in frame.",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/tele10.jpg"),
                    alt: "Teleconference start"
                }
            },
            {
                subtitle: "The Other POV",
                description: "On the web app, we will be able to see the patient and their vitals in real time.",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/tele6.png"),
                    alt: "Teleconference start"
                }
            },
            {
                subtitle: "Ending the Measurement",
                description: "Once the measurement concludes, the administrator should end the meeting by clicking the red 'x' icon on the bottom right of the video player and then click on 'End Meeting for All'",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/tele7.png"),
                    alt: "Teleconference start"
                }
            },
            {
                subtitle: "Subsequent Meetings View",
                description: "Once you're back to the app after you ended the previous one, you'll be able to see the measurement that was previously done in the meeting that has ended, and you're able to start another meeting by clicking 'Join Meeting'",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/tele9.png"),
                    alt: "Teleconference start"
                }
            },
            {
                subtitle: "Accidentally Closed the Zoom Meeting Browser Tab?",
                description: "If you close the browser tab while there is an on-going meeting, you can reconnect to that meeting by clicking on 'Rejoin Meeting'. Clicking on 'Join Meeting' WILL END the previous meeting and start a new one. \n Note: You might see a mirror of your user in the meeting, which should disappear shortly. Do not pay attention to it.",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/tele10.png"),
                    alt: "Teleconference start"
                }
            },
        ]
    },
    additional: {
        title: "Additional Features",
        slides: [
            {
                subtitle: "Changing Patients",
                description: "To switch to a different patient, please use either the back arrow or 'Change Patient' button shown on screen. For your convenience, please avoid using your browser's back button, as this will return you to the login page.",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/change_patient.png"),
                    alt: "Features Overview"
                }
            },
            {
                subtitle: "Adding Room Temperature",
                description: "Please click the 'Room Temp' button in the top-right corner. In the popup window, you can enter your temperature value and select the unit of measurement.",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/room_temp.png"),
                    alt: "Features Overview"
                }
            },
            {
                subtitle: "Important Medication Information",
                description: "Before taking measurements, please check your patient's medication list. Some medications can directly affect results. If your patient has taken any medications, click the 'Medication' button to record both the medication name and when it was taken. This helps ensure accurate results.",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/medication.png"),
                    alt: "Features Overview"
                }
            },
            {
                subtitle: "Entering Manual Measurements",
                description: "If you need to record blood pressure or blood sugar levels that were measured manually, simply click the corresponding buttons to open the entry windows and input your measurements.",
                bgColor: "bg-gradient-blue",
                media: {
                    type: "image",
                    url: require("./faqVisuals/manuel.png"),
                    alt: "Features Overview"
                }
            },


        ]
    }
};

// You can also define custom background gradients
export const gradients = {
    blue: "bg-gradient-blue",
    purple: "bg-gradient-purple",
    green: "bg-gradient-green",
    orange: "bg-gradient-orange"
};

// Define reusable styles
export const styles = {
    gradients: {
        blue: "linear-gradient(135deg, #60A5FA 0%, #3B82F6 100%)",
        purple: "linear-gradient(135deg, #8B5CF6 0%, #6366F1 100%)",
        green: "linear-gradient(135deg, #34D399 0%, #059669 100%)",
        orange: "linear-gradient(135deg, #FBBF24 0%, #D97706 100%)"
    },
    cardShadow: "0 10px 20px rgba(0,0,0,0.2)",
    borderRadius: "20px"
};